import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Header } from 'semantic-ui-react';
import { fetchCategoriesList, categoriesSelectors, CATEGORIES_CONFIG } from '../../features/categories';
import CategoriesList from './CategoriesList';
import { useParams } from 'react-router';
import InfiniteView from "../../components/InfiniteView";
import {setWindowScrollPosition} from "../../components/WindowDimensions";

export default function Categories(props) {

  const {userData, userLocation, mixpanel, dispatch, routeAction, isPageReloaded} = props;

  const matchParams = useParams();
  const categId = matchParams.categId;
  const hasMore = false;
  const loading = useSelector(categoriesSelectors.selectIsListLoading);
  const categories = useSelector(categoriesSelectors.selectCategoriesItems);

  const readCategories = (parent, page) => {
    dispatch(fetchCategoriesList({ refresh: page === 1 }));
  };

  const loadCategories = () => {
    readCategories(categId, 1);
  };

  useEffect(() => {
    if ( routeAction === 'PUSH' || isPageReloaded ) {
      setWindowScrollPosition();
      readCategories(categId, 1);
    }
    if (mixpanel)
      mixpanel.track('Categories View', { ...userLocation, ...userData, categId });
  }, [categId]);

  useEffect(() => {
    if (isPageReloaded) {
      setWindowScrollPosition();
    }
  }, [props]);

  const items =
      categories.filter(
          item => [String(item.parent), String(item.id)].includes(String(categId))
  );

  return (
      <InfiniteView
          headerTitle={`Категории`}
          dataLength={items.length}
          nextFetch={loadCategories}
          hasMore={hasMore}
          dataList={(
              <CategoriesList
                  categories={items}
                  id={categId}
              />
          )}
          mustAuth={false}
          isLoading={loading}
          loaderText="Загружаем категории ..."
          zeroText="Категории отсутствуют"
      />
  );
}



